import React from "react";
import { Link, useLocation } from "react-router-dom";

import { parseQuery } from "../../../../helper/helper";

export const TableRow = (props) => {
  const { userName, userPhone, numbers, cartId, amount, status, ticketType } =
    props;
  const location = useLocation();
  const queryObj = parseQuery(location.search);
  const resultId = queryObj.resultId;
  const linkTo =
    ticketType === "unmarketable"
      ? `/classic/ticket-storage?resultId=${resultId || ""}`
      : `/classic/ticket?cartId=${cartId}`;

  const getStatusText = () => {
    if (status === 4) return "Trúng thưởng";
    return "Không trúng";
  };

  const getStatusClass = () => {
    if (status === 4) return "text-success fw-bold";
    return "text-secondary";
  };

  return (
    <tr>
      <td>
        {userName || ""}
        <br />
        <span>
          <strong className={`text-primary`}>{userPhone || ""}</strong>
        </span>
      </td>
      <td className="text-center">{cartId}</td>
      <td className="text-center">
        <strong>{(numbers || "").split("").join(" ")}</strong>
      </td>
      <td className="text-center">
        {new Intl.NumberFormat("vi-VN").format(amount || 0)}
      </td>
      <td className={`text-center ${getStatusClass()}`}>{getStatusText()}</td>
      <td className="text-center">
        <Link to={linkTo}>Xem vé</Link>
      </td>
    </tr>
  );
};
